export const DEVICE_FINGERPRINT_KEY = 'DEVICE_FINGERPRINT';
